import { Routes } from '@angular/router';
import { BuildingShellComponent } from './pages/building-shell.component';
import { UserComponent } from './pages/user/user.component';
import { MissingBuildingComponent } from './pages/missing-building.component';
import { NoAccessComponent } from './pages/no-access.component';
import { ActivityComponent } from './pages/activity/activity.component';
import { NsideIdentityGuard } from '../shared/services/auth/nSideIdentityGuard';
import { SiteAdminGuard } from '../shared/services/auth/siteAdminGuard';
import { AdminMessagesComponent } from './pages/admin-messages/admin-messages.component';

export const routes: Routes = [
  { path: '', redirectTo: 'missing-building', pathMatch: 'full' },
  { path: 'building', redirectTo: 'missing-building', pathMatch: 'full' },
  { path: 'missing-building', component: MissingBuildingComponent, data: { showShell: false } },
  { path: 'no-access', component: NoAccessComponent, data: { showShell: false } },
  {
    path: 'building/:buildingId/siteAdmin/:siteAdmin/isOrg/:isOrg',
    component: BuildingShellComponent,
    canActivate: [NsideIdentityGuard],
    data: { showShell: false }
  },
  {
    path: 'user',
    component: UserComponent,
    canActivate: [NsideIdentityGuard, SiteAdminGuard]
  },
  {
    path: 'activity',
    component: ActivityComponent,
    canActivate: [NsideIdentityGuard, SiteAdminGuard]
  },
  {
    path: 'admin-messages',
    component: AdminMessagesComponent,
    canActivate: [NsideIdentityGuard, SiteAdminGuard]
  },
  { path: '**', redirectTo: 'missing-building' }
];
